import { useMutation } from '@tanstack/vue-query';
import { PHONE_VERIFIED_VIA_EMAIL_FALLBACK } from '~/constants/phoneVerification';

type SendEmailFallbackResponse = {
  success: true;
  data: { maskedEmail: string; expiresAt: string; resendAvailableAt: string };
};

// Emails a code; the server only allows it after Twilio really refused the number on file.
export const useSendPhoneEmailFallback = () => {
  const authStore = useAuthStore();
  return useMutation({
    mutationFn: () =>
      $fetch<SendEmailFallbackResponse>('/api/auth/phone/email-fallback/send', {
        method: 'POST',
        headers: { Authorization: `Bearer ${authStore.token}` },
      }),
  });
};

export const useVerifyPhoneEmailFallback = () => {
  const authStore = useAuthStore();
  return useMutation({
    mutationFn: (code: string) =>
      $fetch<{ success: true }>('/api/auth/phone/email-fallback/verify', {
        method: 'POST',
        body: { code },
        headers: { Authorization: `Bearer ${authStore.token}` },
      }),
    onSuccess: () => {
      if (!authStore.user) return;
      authStore.updateUser({
        ...authStore.user,
        phoneVerified: true,
        phoneVerifiedVia: PHONE_VERIFIED_VIA_EMAIL_FALLBACK,
      });
    },
  });
};
